import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProductFavoriteRequest } from '../models/product-favorite.model';

@Injectable({
    providedIn: 'root'
})
export class ProductFavoriteService {

    private url = environment.api + "api/erp/inventory/product-favorite";

    constructor(
        private http: HttpClient
    ) {
    }

    getByWarehouse(warehouseId: number) {
        return this.http.get(this.url + "/warehouse/" + warehouseId);
    }

    getProductsByWarehouse(warehouseId: number) {
        return this.http.get(this.url + "/warehouse-products/" + warehouseId);
    }

    getByProduct(productId: number) {
        return this.http.get(this.url + "/product/" + productId);
    }

    create(request: ProductFavoriteRequest) {
        return this.http.post(this.url,request);
    }

    createMultiple(request: ProductFavoriteRequest[]) {
        return this.http.post<any[]>( this.url + "/create-multiple", request);
    }

    delete(favoriteId: number) {
        return this.http.delete(this.url + "/" + favoriteId);
    }
}